// -----------------------------------------------------------
// FloraIQ - Vocabulario e textos fixos do portal publico
// -----------------------------------------------------------
// Apenas listas descritivas (servicos, tipos, etapas, temas). Nenhum numero,
// registro ou indicador: o portal ainda nao tem API publica de dados.

/** [icone, titulo, descricao] */
export const publicServices: [string, string, string][] = [
  ['tree', 'Consultar uma árvore', 'Informações e localização do exemplar'],
  ['clipboard', 'Solicitar vistoria', 'Pedido de avaliação técnica'],
  ['alert', 'Informar ocorrência', 'Problemas na arborização'],
  ['search', 'Acompanhar protocolo', 'Andamento do seu pedido'],
  ['leaf', 'Plantio e compensação', 'Como participar'],
  ['book', 'Educação ambiental', 'Conteúdos e iniciativas'],
];

export const treeBenefits = [
  'Mais qualidade de vida',
  'Conforto térmico',
  'Ar mais limpo',
  'Biodiversidade urbana',
  'Cidades mais resilientes',
];

export const publicTransparencyTopics = [
  'Inventário público',
  'Histórico de manejos',
  'Relatórios e mapas',
  'Indicadores por região',
  'Dados abertos',
];

/** [numero, etapa, descricao, icone] */
export const inspectionRequestSteps: [string, string, string, string][] = [
  ['1', 'Solicitação', 'O cidadão descreve o pedido e a localização', 'clipboard'],
  ['2', 'Análise', 'A equipe técnica analisa as informações', 'search'],
  ['3', 'Vistoria', 'A vistoria é realizada em campo', 'user'],
  ['4', 'Retorno', 'O cidadão recebe o resultado e as orientações', 'file'],
];

export const inspectionRequestTopics = [
  'Árvore com risco de queda',
  'Galhos em contato com rede elétrica',
  'Árvore causando danos à calçada',
  'Solicitação de poda',
  'Plantio de nova árvore',
];

/** [icone, tipo] */
export const occurrenceTypes: [string, string][] = [
  ['tree', 'Queda de galho'],
  ['alert', 'Risco de queda'],
  ['scissors', 'Poda irregular'],
  ['leaf', 'Praga / doença'],
  ['alert', 'Conflito com fiação'],
  ['users', 'Acessibilidade'],
];

/** [imagem, categoria, chamada] */
export const campaignCategories: [string, string, string][] = [
  ['campaign-plantio.jpg', 'Plantio Urbano', 'Mais árvores em mais lugares'],
  ['campaign-educacao.jpg', 'Educação Ambiental', 'Conhecimento que transforma'],
  ['campaign-adocao.jpg', 'Adoção de Árvores', 'Cuide de uma árvore da sua cidade'],
  ['campaign-voluntariado.jpg', 'Voluntariado', 'Gente que planta um futuro melhor'],
  ['campaign-semana.jpg', 'Semanas Verdes', 'Mobilização por uma Goiânia mais verde'],
  ['campaign-compensacao.jpg', 'Compensação Ambiental', 'Transforme obrigações em mais natureza'],
];

export const openDataThemes = [
  'Inventário arbóreo',
  'Vistorias realizadas',
  'Manejos e intervenções',
  'Áreas verdes e parques',
  'Ocorrências ambientais',
  'Campanhas e educação ambiental',
];
